import { createReducer } from '@reduxjs/toolkit'
import cloneDeep from 'lodash/cloneDeep'

import { reportsSummaryTableColumnsConfig } from 'configuration/tables/reportsTable'
import { serializeColumns } from 'helpers/tables'
import { getDefaultTable } from 'reducers/ui/defaults'

const defaultState = {
    table: getDefaultTable(serializeColumns(reportsSummaryTableColumnsConfig), {
        sorter: {
            field: ['created_date'],
            order: 'descend',
        },
    }),
    error: null,
}

export default createReducer(cloneDeep(defaultState), () => {}) // create clone, so the defaultState is not mutated
